import { render } from "./MenuLateral.vue?vue&type=template&id=a32b3ad2&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=a32b3ad2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32b3ad2"]])

export default __exports__